export const steps = ["service", "location"];
export const ns = "common:initial_master_setup_modal.";
